<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>药房审核详情</span>
        <span
          style="background-color: #ffecda;color:#f48a15;"
          class="status"
          v-if="detail.status==2"
        >待审核</span>
        <span
          style="background-color: #e5f1e3;color: #669961;"
          class="status"
          v-if="detail.status==3"
        >审核通过</span>
        <span
          style="background-color: #ffe4e4;color: #d76b59;"
          class="status"
          v-if="detail.status==4"
        >审核不通过</span>
      </span>

      <el-button type="primary" style="width:92px;" size="medium" @click="back">返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="padding:20px 24px 10px">
          <span class="itemtitle">提交日期：</span>
          <span>{{detail.create_time}}</span>
          <span class="itemtitle" style="margin-left:50px">账号：</span>
          <span>{{detail.user_phone}}</span>
        </div>
        <div style="height:1px;width:100%;background:#D7D7D7"></div>
        <div style="padding: 24px 20px;">
          <div class="itemtitle">基本信息</div>
          <div class="infobox">
            <div style="margin-bottom:20px">
              <span style="display:inline-block;width:300px">
                <span class="gray">药房名称：</span>
                <span class="black">{{detail.hospital_name}}</span>
              </span>
              <span>
                <span class="gray">药房类型：</span>
                <span class="black">{{detail.org_type}}</span>
              </span>
            </div>
            <div>
              <span style="display:inline-block;width:300px">
                <span class="gray">纳税人识别号：</span>
                <span class="black">{{detail.identification_number}}</span>
              </span>
              <span>
                <span class="gray">所在区域：</span>
                <span class="black">{{detail.address}}</span>
              </span>
            </div>
          </div>

          <div class="itemtitle">机构证照</div>
          <div style="margin-bottom:30px">
            <span class="gray">是否二合一：</span>
            <span class="black" v-if="detail.two_one">是</span>
            <span class="black" v-else>否</span>
          </div>
          <div class="imglist">
            <div class="imgitem">
              <div class="imgtext">营业执照</div>
              <div class="imgbox">
                <el-image class="img" :src="business_license" :preview-src-list="imgList"></el-image>
              </div>
            </div>
            <div class="imgitem">
              <div class="imgtext">药品经营许可证</div>
              <div class="imgbox">
                <el-image class="img" :src="drug_trade_license" :preview-src-list="imgList"></el-image>
              </div>
            </div>
            <div class="imgitem" v-if="!detail.two_one">
              <div class="imgtext">Gsp</div>
              <div class="imgbox">
                <el-image class="img" :src="gsp" :preview-src-list="imgList"></el-image>
              </div>
            </div>
            <div class="imgitem">
              <div class="imgtext">法人代表身份证（正面）</div>
              <div class="imgbox">
                <el-image class="img" :src="id_card_face" :preview-src-list="imgList"></el-image>
              </div>
            </div>
            <div class="imgitem">
              <div class="imgtext">法人代表身份证（反面）</div>
              <div class="imgbox">
                <el-image class="img" :src="id_card_side" :preview-src-list="imgList"></el-image>
              </div>
            </div>
          </div>
          <div style="margin-top:40px" v-if="detail.status==2">
            <el-button
              plain
              @click="examine(4)"
              style="width:100px"
              :disabled="module_id_array[0]?!module_id_array.includes('90'):false"
            >不通过</el-button>
            <el-button
              type="primary"
              @click="examine(3)"
              style="width:100px"
              :disabled="module_id_array[0]?!module_id_array.includes('90'):false"
            >通过</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import axios from "../../../service/axios/axios";
import hospital from "../../../api/hospital";
import _ from "lodash";
export default {
  data() {
    return {
      business_license: "",
      drug_trade_license: "",
      gsp: "",
      id_card_face: "",
      id_card_side: "",
      detail: {},
      imgList: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取药房审核详情
    getReviewed() {
      let reviewed_id = this.$route.query.reviewed_id;
      hospital
        .getHospitalAuthInfo({ reviewed_id })
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data.info;
            let data = res.data.info;
            this.detail.create_time = platform.timestampToDate(
              this.detail.create_time
            );
            this.requestImg(data.business_license, "business_license");
            this.requestImg(data.drug_trade_license, "drug_trade_license");
            if (!data.two_one) {
              this.requestImg(data.gsp, "gsp");
            }
            this.requestImg(data.id_card_face, "id_card_face");
            this.requestImg(data.id_card_side, "id_card_side");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value }
        })
        .then(res => {
          this[imgname] = res;
          this.imgList.push(res);
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    //审核
    examine(status) {
      let reviewed_id = this.$route.query.reviewed_id;
      let auth_status = status;
      let text = "";
      if (status == 3) {
        text = "通过";
      } else {
        text = "未通过";
      }
      this.$confirm(`是否审核${text}？`, "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          hospital.auditHospital({ reviewed_id, auth_status }).then(res => {
            if (res.code == 0) {
              this.$message.success(`该药房审核${text}!`);
              this.back();
            }
          });
        })
        .catch();
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getReviewed();
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 100px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
</style>